module.exports = __webpack_public_path__ + "img/page-not-found.e869c7d2.webp";